import React from 'react';
import { Typography } from 'antd';



function AdnSubtitle({text}) {
  const { Title } = Typography;
  return <h4>{text}</h4>;
}

export default AdnSubtitle;
